import script from "./VDialogHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./VDialogHeader.vue?vue&type=script&lang=ts&setup=true"

import "./VDialogHeader.vue?vue&type=style&index=0&id=2e36fe6f&lang=sass"

const __exports__ = script;

export default __exports__